import { motion } from 'framer-motion';

const Modal = ({ selectedImg, setSelectedImg }) => {
  const handleClick = (e) => {
    if (e.target.classList.contains('backdrop')) {
      setSelectedImg(null);
    }
  };

  return (
    <section className="text-gray-600 body-font">
      <motion.div
        className="backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        onClick={handleClick}
      >
        <motion.img
          alt="gallery"
          src={selectedImg}
          initial={{ y: '-100vh' }}
          animate={{ y: 0 }}
        />
      </motion.div>
    </section>
  );
};

export default Modal;
